import axios from "../http/axios";

export default {
  getPesquisaSatisfacao: (path) => {
    return axios.get("/pesquisa-satisfacao", { params: path }).then((res) => {
      return res.data;
    });
  },
};
